/*
  Configuratorul de blend ONE Coffee.

  DE CE STA AICI SI NU IN SECTIUNE. Restul sectiunilor one-* isi tin scriptul
  inauntru, pentru ca au zece-douazeci de linii. Asta are peste patru sute.
  Tinut in asset, o corectie de comportament se urca singura, fara sa rescriem
  si CSS-ul si markup-ul si schema. CSS-ul ramane in sectiune, pentru ca are
  nevoie de section.id la fiecare selector.

  SURSA DE ADEVAR E FORMULARUL NATIV. Sub interfata desenata exista cinci
  perechi de select-uri reale, cafea si procent, plus campurile de cantitate si
  macinare. JS-ul doar le imbraca: citeste din ele la pornire si scrie in ele la
  fiecare schimbare. Consecinte: fara JS pagina ramane un formular functional,
  iar cand vom lega configuratorul de cos schimbam doar functia care serializeaza,
  nu interfata.

  INVARIANTUL. Suma procentelor plus procentul liber e mereu 100. Nu exista
  stare in care banda sa nu fie plina. Asa omul vede tot timpul cat i-a mai
  ramas, iar butonul de trimitere se deblocheaza exact cand liber ajunge la zero.

  UNITATEA DE MASURA E CEA DE 250 G, NU O PUNGA. Starea tine numarul de unitati,
  nu kilogramele, pentru ca asta e unitatea in care se coteaza, se descarca in
  gestiune si se factureaza. Kilogramele afisate sunt derivate: u / 4. Minimul si
  maximul vin din sectiune, prin data-umin si data-umax, ca sa nu fie nevoie de o
  modificare de cod cand se schimba politica de comanda.

  PRETUL PORNESTE DE LA UNITATE. Sectiunea trimite in JSON pretul variantei de
  250 g a fiecarei cafele, nu pe cel de la 1 kg. pretPeUnitate() il pondereaza cu
  procentele, iar restul se deduce: kilogramul e unitatea ori patru, totalul e
  unitatea ori numarul de unitati. Diferenta fata de pretul de la 1 kg acopera
  amestecul si ambalarea facute de mana in hala. Nu e o comanda, e o cerere, si
  textul de langa suma spune asta.

  DE LA PROCENTE LA UNITATI INTREGI. Omul dozeaza in procente, pentru ca asa se
  gandeste o reteta, dar in hala si pe factura se lucreaza in unitati de 250 g,
  iar o unitate nu se taie in doua. impartire() traduce procentele in unitati
  intregi prin metoda restului celui mai mare, si suma lor e exact cantitatea
  comandata. Din impartirea asta se calculeaza pe urma tot: costul fiecarei
  cafele, totalul, pretul unitatii si liniile din cos. Adica pe ecran scrie
  exact ce se descarca din gestiune si exact ce se plateste, nu o aproximare
  care se rotunjeste altfel la casa.
*/

(function () {
  'use strict';

  var root = document.querySelector('[data-blend-lab]');
  if (!root) return;

  var sursa = root.querySelector('[data-blend-date]');
  var CAFELE = [];
  try { CAFELE = JSON.parse(sursa.textContent); } catch (e) { return; }
  if (!CAFELE.length) return;

  var MAX = parseInt(root.getAttribute('data-max'), 10) || 5;
  var PAS = 10;
  var MIN = 10;
  var UMIN = parseInt(root.getAttribute('data-umin'), 10) || 8;
  var UMAX = parseInt(root.getAttribute('data-umax'), 10) || 40;
  if (UMAX < UMIN) UMAX = UMIN;

  var harta = {};
  CAFELE.forEach(function (c) { harta[c.h] = c; });

  /* ---------- stare ---------- */

  var stare = { sloturi: [], u: UMIN, macinare: '', nume: '', atins: false };

  /* Kilogramele nu se tin in stare, se calculeaza. Daca le-am tine pe amandoua
     ar exista o clipa in care nu sunt de acord una cu alta, si aia e clipa in
     care iese o eticheta cu alt gramaj decat comanda. */
  function kg() { return stare.u / 4; }
  function kgText() {
    return kg().toLocaleString('ro-RO', {
      minimumFractionDigits: 0, maximumFractionDigits: 2
    }) + ' kg';
  }

  /* ---------- elemente ---------- */

  var q = function (sel) { return root.querySelector(sel); };
  var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var banda = q('[data-banda]');
  var listaSloturi = q('[data-sloturi]');
  var totalTxt = q('[data-total]');
  var btnEchilibru = q('[data-echilibreaza]');
  var noteBox = q('[data-note]');
  var pretKgTxt = q('[data-pret-kg]');
  var pretUTxt = q('[data-pret-u]');
  var pretTotalTxt = q('[data-pret-total]');
  var uVal = q('[data-u-val]');
  var uNota = q('[data-u-nota]');
  var grila = q('[data-grila]');
  var cautare = q('[data-cautare]');
  var contorFiltru = q('[data-contor]');
  var numeInput = q('[data-nume]');
  var eticheta = q('[data-eticheta]');
  var btnPng = q('[data-descarca]');
  var zonaShare = q('[data-share]');
  var btnShareNativ = q('[data-share-nativ]');
  var contorNume = q('[data-nume-contor]');
  var submitBtn = q('[data-trimite]');
  var bara = q('[data-bara]');
  var baraPct = q('[data-bara-pct]');
  var baraPret = q('[data-bara-pret]');
  var fallback = q('[data-fallback]');
  var autorInput = q('[data-autor]');
  var listaUnitati = q('[data-unitati]');
  var cosTotal = q('[data-cos-total]');
  var btnCos = q('[data-cos]');
  var cosStare = q('[data-cos-stare]');

  var selCafea = [], selProcent = [];
  for (var i = 1; i <= MAX; i++) {
    selCafea.push(q('[name="contact[cafea_' + i + ']"]'));
    selProcent.push(q('[name="contact[procent_' + i + ']"]'));
  }
  var selKg = q('[name="contact[cantitate]"]');
  var selMac = q('[name="contact[macinare]"]');

  /* ---------- utilitare ---------- */

  function suma() {
    return stare.sloturi.reduce(function (t, s) { return t + s.p; }, 0);
  }
  function liber() { return 100 - suma(); }

  function lei(bani) {
    return (bani / 100).toLocaleString('ro-RO', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' lei';
  }

  function pozitie(h) {
    for (var i = 0; i < stare.sloturi.length; i++) {
      if (stare.sloturi[i].h === h) return i;
    }
    return -1;
  }

  /* Repartitiile de pornire. Prima cafea aleasa ramane baza blendului, restul
     se aseaza sub ea. Se aplica doar cat timp omul nu a atins niciun stepper. */
  var SABLOANE = {
    1: [100], 2: [50, 50], 3: [40, 30, 30], 4: [40, 20, 20, 20], 5: [40, 15, 15, 15, 15]
  };

  function normalizeaza() {
    var sab = SABLOANE[stare.sloturi.length];
    if (!sab) return;
    stare.sloturi.forEach(function (s, i) { s.p = sab[i]; });
  }

  /* ---------- operatii ---------- */

  function adauga(h) {
    if (pozitie(h) > -1 || !harta[h] || stare.sloturi.length >= MAX) return;
    stare.sloturi.push({ h: h, p: 0 });
    if (!stare.atins) {
      normalizeaza();
    } else {
      var l = liber();
      if (l >= MIN) {
        stare.sloturi[stare.sloturi.length - 1].p = MIN;
      } else {
        /* Nu mai e loc liber, deci imprumutam un pas de la cea mai mare. */
        var maxIdx = 0;
        stare.sloturi.forEach(function (s, i) { if (s.p > stare.sloturi[maxIdx].p) maxIdx = i; });
        if (stare.sloturi[maxIdx].p - PAS >= MIN) {
          stare.sloturi[maxIdx].p -= PAS;
          stare.sloturi[stare.sloturi.length - 1].p = MIN;
        } else {
          stare.sloturi.pop();
          return;
        }
      }
    }
    randeaza();
  }

  function scoate(h) {
    var i = pozitie(h);
    if (i < 0) return;
    stare.sloturi.splice(i, 1);
    if (!stare.atins) normalizeaza();
    randeaza();
  }

  function seteaza(h, p) {
    var i = pozitie(h);
    if (i < 0) return;
    p = Math.round(p / PAS) * PAS;
    var altele = suma() - stare.sloturi[i].p;
    p = Math.max(MIN, Math.min(100 - altele, p));
    if (p === stare.sloturi[i].p) return;
    stare.sloturi[i].p = p;
    stare.atins = true;
    randeaza();
  }

  function echilibreaza() {
    if (!stare.sloturi.length) return;
    var l = liber();
    var garda = 0;
    while (l > 0 && garda < 40) {
      var minIdx = 0;
      stare.sloturi.forEach(function (s, i) { if (s.p < stare.sloturi[minIdx].p) minIdx = i; });
      stare.sloturi[minIdx].p += PAS;
      l -= PAS;
      garda++;
    }
    stare.atins = true;
    randeaza();
  }

  /* ---------- profilul blendului ---------- */

  function profil() {
    var s = suma();
    if (!s) return null;
    var pr = 0, ac = 0, sc = 0, greutateScor = 0;
    stare.sloturi.forEach(function (sl) {
      var c = harta[sl.h];
      pr += c.prajire * sl.p;
      ac += c.aciditate * sl.p;
      if (c.scor) { sc += c.scor * sl.p; greutateScor += sl.p; }
    });
    return {
      prajire: pr / s,
      aciditate: ac / s,
      scor: greutateScor ? sc / greutateScor : null
    };
  }

  function noteBlend() {
    var acc = {};
    stare.sloturi.forEach(function (sl) {
      var c = harta[sl.h];
      if (!c.note || !c.note.length) return;
      var cota = sl.p / c.note.length;
      c.note.forEach(function (n) { acc[n] = (acc[n] || 0) + cota; });
    });
    return Object.keys(acc)
      .map(function (n) { return { nume: n, greutate: acc[n] }; })
      .sort(function (a, b) { return b.greutate - a.greutate; })
      .slice(0, 8);
  }

  /* ---------- unitati ---------- */

  /* Metoda restului celui mai mare. Fiecare cafea ia partea intreaga din
     procentul ei, apoi unitatile ramase se dau celor cu restul cel mai mare.
     Suma iese exact stare.u, deci nu se pierde si nu se inventeaza cantitate. */
  function impartire() {
    var n = stare.sloturi.length;
    if (!n) return [];
    var exacte = stare.sloturi.map(function (sl) { return sl.p * stare.u / 100; });
    var u = exacte.map(function (e) { return Math.floor(e); });
    var dat = u.reduce(function (t, x) { return t + x; }, 0);
    var ramase = stare.u - dat;
    var ordine = exacte.map(function (e, i) { return { i: i, r: e - Math.floor(e) }; })
      .sort(function (a, b) { return b.r - a.r; });
    for (var k = 0; k < ramase; k++) u[ordine[k % n].i] += 1;
    /* Nicio cafea nu ramane pe zero. Daca rotunjirea a golit una, ii dam o
       unitate de la cea mai incarcata: altfel ar scrie pe eticheta o origine
       care nu intra deloc in punga. */
    for (var i = 0; i < n; i++) {
      if (u[i] > 0) continue;
      var maxI = 0;
      for (var j = 1; j < n; j++) { if (u[j] > u[maxI]) maxI = j; }
      if (u[maxI] > 1) { u[maxI] -= 1; u[i] = 1; }
    }
    return u;
  }

  /* Impartirea curenta. Se recalculeaza o singura data pe randare, in randeaza(),
     ca toate bucatile de interfata sa vorbeasca despre aceleasi unitati. */
  var unitati = [];

  /* Pretul porneste de la unitatile reale, nu de la procente. Asa suma de pe
     ecran e fix suma din cos, la ultimul ban. */
  function totalBani() {
    return stare.sloturi.reduce(function (t, sl, i) {
      return t + harta[sl.h].pret * (unitati[i] || 0);
    }, 0);
  }

  function pretPeUnitate() { return stare.u ? totalBani() / stare.u : 0; }

  function pretPeKg() { return pretPeUnitate() * 4; }

  /* ---------- randare ---------- */

  function semnaturaFocus() {
    var a = document.activeElement;
    if (!a || !root.contains(a) || !a.getAttribute) return null;
    var chei = ['data-h', 'data-plus', 'data-min', 'data-scoate', 'data-u'];
    for (var i = 0; i < chei.length; i++) {
      var v = a.getAttribute(chei[i]);
      if (v) return '[' + chei[i] + '="' + v + '"]';
    }
    return null;
  }

  function redaFocus(sel) {
    if (!sel) return;
    var el = root.querySelector(sel);
    if (el && typeof el.focus === 'function' && !el.disabled) el.focus();
  }

  function randeaza() {
    var focus = semnaturaFocus();
    unitati = impartire();
    randeazaBanda();
    randeazaSloturi();
    randeazaTotal();
    randeazaNote();
    randeazaCantitate();
    randeazaPret();
    randeazaGrila();
    randeazaEticheta();
    randeazaCos();
    scrieFormular();
    redaFocus(focus);
  }

  function randeazaBanda() {
    banda.innerHTML = '';
    stare.sloturi.forEach(function (sl, i) {
      var c = harta[sl.h];
      var seg = document.createElement('div');
      seg.className = 'bl__seg bl__seg--' + (i + 1);
      seg.style.width = sl.p + '%';
      seg.setAttribute('role', 'slider');
      seg.setAttribute('tabindex', '0');
      seg.setAttribute('aria-label', 'Procent pentru ' + c.nume);
      seg.setAttribute('aria-valuemin', MIN);
      seg.setAttribute('aria-valuemax', 100 - (suma() - sl.p));
      seg.setAttribute('aria-valuenow', sl.p);
      seg.setAttribute('aria-valuetext', sl.p + ' la suta ' + c.nume);
      seg.setAttribute('data-h', sl.h);
      if (sl.p >= 20) {
        seg.innerHTML = '<span class="bl__seg-p">' + sl.p + '%</span>';
      }
      var man = document.createElement('span');
      man.className = 'bl__maner';
      man.setAttribute('aria-hidden', 'true');
      man.setAttribute('data-maner', sl.h);
      seg.appendChild(man);
      banda.appendChild(seg);
    });
    var l = liber();
    if (l > 0) {
      var gol = document.createElement('div');
      gol.className = 'bl__seg bl__seg--liber';
      gol.style.width = l + '%';
      gol.innerHTML = l >= 20 ? '<span class="bl__seg-p">' + l + '% liber</span>' : '';
      banda.appendChild(gol);
    }
  }

  function randeazaSloturi() {
    listaSloturi.innerHTML = '';
    if (!stare.sloturi.length) {
      var gol = document.createElement('p');
      gol.className = 'bl__gol';
      gol.textContent = 'Alege prima cafea din raft. Poți pune până la ' + MAX + ' într-un blend.';
      listaSloturi.appendChild(gol);
      return;
    }
    stare.sloturi.forEach(function (sl, i) {
      var c = harta[sl.h];
      var rand = document.createElement('div');
      rand.className = 'bl__slot';
      rand.innerHTML =
        '<span class="bl__pastila bl__pastila--' + (i + 1) + '" aria-hidden="true">' + (i + 1) + '</span>' +
        '<span class="bl__slot-nume">' + c.nume +
          '<span class="bl__slot-meta">' + c.origine + ' · ' + lei(c.pret) + ' / unitate · ' + (unitati[i] || 0) + ' × 250 g</span>' +
        '</span>' +
        '<span class="bl__step">' +
          '<button type="button" class="bl__b" data-min="' + sl.h + '" aria-label="Scade 10 la suta din ' + c.nume + '">&minus;</button>' +
          '<output class="bl__val">' + sl.p + '%</output>' +
          '<button type="button" class="bl__b" data-plus="' + sl.h + '" aria-label="Crește cu 10 la suta ' + c.nume + '">+</button>' +
        '</span>' +
        '<span class="bl__cost">' + lei(c.pret * (unitati[i] || 0)) + '</span>' +
        '<button type="button" class="bl__x" data-scoate="' + sl.h + '" aria-label="Scoate ' + c.nume + ' din blend">&times;</button>';
      listaSloturi.appendChild(rand);
    });
  }

  function randeazaTotal() {
    var s = suma(), l = liber();
    var ok = s === 100 && stare.sloturi.length > 0;
    totalTxt.textContent = !stare.sloturi.length
      ? 'Rețeta e goală.'
      : (ok ? 'Total 100%. Rețeta e completă.' : 'Total ' + s + '%. Mai ai ' + l + '% de repartizat.');
    totalTxt.className = 'bl__total' + (ok ? ' is-ok' : '');
    btnEchilibru.hidden = ok || !stare.sloturi.length;
    root.classList.toggle('is-valid', ok);
    if (submitBtn) submitBtn.disabled = !ok;
    if (bara) bara.hidden = stare.sloturi.length === 0;
    if (baraPct) baraPct.textContent = ok ? '100%' : s + '%';
  }

  function randeazaNote() {
    var n = noteBlend();
    if (!n.length) {
      noteBox.innerHTML = '<p class="bl__gol">Notele de gust apar pe măsură ce alegi cafele.</p>';
      return;
    }
    var maxG = n[0].greutate;
    noteBox.innerHTML = '<ul class="bl__note">' + n.map(function (x) {
      var w = Math.max(6, Math.round(x.greutate / maxG * 100));
      return '<li><span class="bl__nota-n">' + x.nume + '</span>' +
             '<span class="bl__nota-b" aria-hidden="true"><i style="width:' + w + '%"></i></span></li>';
    }).join('') + '</ul>';
  }

  /* Cantitatea. Butoanele se sting la capete, ca sa nu para ca aplicatia nu
     raspunde cand omul apasa si nu se intampla nimic. */
  function randeazaCantitate() {
    if (uVal) uVal.textContent = stare.u + ' × 250 g';
    if (uNota) uNota.textContent = 'Adică ' + kgText() + '. Minimum ' + UMIN + ' unități de 250 g.';
    qa('[data-u]').forEach(function (b) {
      var d = parseInt(b.getAttribute('data-u'), 10) || 0;
      b.disabled = d < 0 ? stare.u <= UMIN : stare.u >= UMAX;
    });
  }

  function randeazaPret() {
    var pu = pretPeUnitate();
    var gol = !stare.sloturi.length;
    pretKgTxt.textContent = gol ? '0,00 lei' : lei(pretPeKg());
    if (pretUTxt) pretUTxt.textContent = gol ? '0,00 lei' : lei(pu);
    pretTotalTxt.textContent = gol ? '0,00 lei' : lei(totalBani());
    if (baraPret) baraPret.textContent = lei(totalBani());
  }

  function randeazaGrila() {
    var plin = stare.sloturi.length >= MAX;
    qa('[data-card]').forEach(function (card) {
      var h = card.getAttribute('data-card');
      var ales = pozitie(h) > -1;
      card.classList.toggle('is-ales', ales);
      card.setAttribute('aria-pressed', ales ? 'true' : 'false');
      card.disabled = !ales && plin;
      var bad = card.querySelector('[data-card-nr]');
      if (bad) {
        bad.textContent = ales ? String(pozitie(h) + 1) : '';
        bad.className = 'bl__card-nr' + (ales ? ' bl__pastila--' + (pozitie(h) + 1) : '');
      }
    });
    root.classList.toggle('is-plin', plin);
    var gol = stare.sloturi.length === 0;
    if (btnPng) btnPng.disabled = gol;
    if (zonaShare) zonaShare.hidden = gol;
    if (btnShareNativ) btnShareNativ.hidden = gol || !navigator.share;
    if (contorNume) contorNume.textContent = String((stare.nume || '').length);
  }

  /* ---------- eticheta ---------- */

  /* Logoul e o poza externa. Un SVG serializat si desenat pe canvas nu incarca
     resurse din afara, deci daca lasam href-ul asa, logoul se vede in pagina
     dar lipseste din PNG-ul descarcat. De aceea il aducem o data, il facem
     data URL si il punem inapoi in SVG. Poza sta pe acelasi domeniu, deci
     canvas-ul nu se murdareste si exportul merge. */
  function pregatesteLogo() {
    var img = eticheta && eticheta.querySelector('[data-et-logo]');
    if (!img) return;
    var src = img.getAttribute('href') || img.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
    if (!src || src.indexOf('data:') === 0) return;
    fetch(src, { mode: 'same-origin' })
      .then(function (r) { return r.ok ? r.blob() : null; })
      .then(function (b) {
        if (!b) return;
        var fr = new FileReader();
        fr.onload = function () {
          img.setAttribute('href', fr.result);
          img.removeAttributeNS('http://www.w3.org/1999/xlink', 'href');
        };
        fr.readAsDataURL(b);
      })
      .catch(function () { /* ramane href-ul normal, se vede in pagina */ });
  }

  /* Numele incape pe doua randuri. Taiem la ultimul spatiu dinaintea limitei,
     ca sa nu rupem un cuvant in doua. */
  function imparteNume(nume, maxim) {
    if (nume.length <= maxim) return [nume, ''];
    var taiere = nume.lastIndexOf(' ', maxim);
    if (taiere < 6) taiere = maxim;
    return [nume.slice(0, taiere).trim(), nume.slice(taiere).trim()];
  }

  function randeazaEticheta() {
    if (!eticheta) return;
    var nume = (stare.nume || '').trim() || 'Blendul tău';
    var r1 = eticheta.querySelector('[data-et-nume]');
    var r2 = eticheta.querySelector('[data-et-nume2]');
    var marime = nume.length > 30 ? 20 : nume.length > 22 ? 24 : nume.length > 15 ? 27 : 30;
    var limita = Math.round(1100 / marime);
    var parti = imparteNume(nume, limita);
    r1.textContent = parti[0];
    r1.setAttribute('font-size', String(marime));
    if (r2) { r2.textContent = parti[1]; r2.setAttribute('font-size', String(marime)); }

    var banda = eticheta.querySelector('[data-et-banda]');
    banda.innerHTML = '';
    var x = 24;
    stare.sloturi.forEach(function (sl, i) {
      var w = sl.p / 100 * 272;
      var rc = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rc.setAttribute('x', x.toFixed(1)); rc.setAttribute('y', '258');
      rc.setAttribute('width', w.toFixed(1)); rc.setAttribute('height', '14');
      rc.setAttribute('class', 'et__seg et__seg--' + (i + 1));
      banda.appendChild(rc);
      x += w;
    });

    var linii = eticheta.querySelector('[data-et-reteta]');
    linii.innerHTML = '';
    stare.sloturi.forEach(function (sl, i) {
      var c = harta[sl.h];
      var y = 302 + i * 24;
      var pc = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      pc.setAttribute('x', '24'); pc.setAttribute('y', String(y));
      pc.setAttribute('class', 'et__proc et__pct--' + (i + 1));
      pc.textContent = sl.p + '%';
      linii.appendChild(pc);
      var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      t.setAttribute('x', '68'); t.setAttribute('y', String(y));
      t.setAttribute('class', 'et__linie');
      t.textContent = c.nume.length > 26 ? c.nume.slice(0, 25) + '…' : c.nume;
      linii.appendChild(t);
    });

    var p = profil();
    eticheta.querySelector('[data-et-meta]').textContent =
      kgText() + ' · ' + stare.u + ' × 250 g · ' + (stare.macinare || 'boabe') +
      (p ? ' · prăjire ' + p.prajire.toFixed(1) + ' / aciditate ' + p.aciditate.toFixed(1) : '');
  }

  /* ---------- descarcare si partajare ---------- */

  /* Fundalul desenat pe canvas trebuie sa fie acelasi alb ca dreptunghiul din
     SVG. Eticheta pleaca la imprimanta termica de etichete din hala, care nu
     stie sa scoata fundal inchis, si oricum l-ar manca in toner. */
  function etichetaBlob(gata) {
    if (!eticheta) { gata(null); return; }
    var clona = eticheta.cloneNode(true);
    clona.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    clona.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    var xml = new XMLSerializer().serializeToString(clona);
    var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
    var img = new Image();
    img.onload = function () {
      var c = document.createElement('canvas');
      c.width = 640; c.height = 920;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(img, 0, 0, c.width, c.height);
      c.toBlob(function (blob) { gata(blob); }, 'image/png');
    };
    img.onerror = function () { gata(null); };
    img.src = url;
  }

  function numeFisier() {
    var n = (stare.nume || 'fara-nume').toLowerCase()
      .replace(/[ăâ]/g, 'a').replace(/[î]/g, 'i').replace(/[șş]/g, 's').replace(/[țţ]/g, 't')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return 'blend-one-' + (n || 'fara-nume') + '.png';
  }

  function descarcaPng(dupa) {
    etichetaBlob(function (blob) {
      if (!blob) return;
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = numeFisier();
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
      if (dupa) dupa();
    });
  }

  function adresaPaginii() {
    return location.origin + location.pathname;
  }

  function textPartajare() {
    var buc = stare.sloturi.map(function (sl) { return sl.p + '% ' + harta[sl.h].nume; });
    var nume = (stare.nume || '').trim();
    return 'Mi-am compus blendul meu la ONE Coffee' + (nume ? ', ' + nume : '') + '. ' +
      (buc.length ? buc.join(', ') + '. ' : '');
  }

  function deschideLink(care) {
    var u = encodeURIComponent(adresaPaginii());
    var t = encodeURIComponent(textPartajare());
    var adrese = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
      x: 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u,
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + u,
      whatsapp: 'https://api.whatsapp.com/send?text=' + t + '%20' + u
    };
    if (!adrese[care]) return;
    window.open(adrese[care], '_blank', 'noopener,noreferrer,width=640,height=640');
  }

  /* Instagram si TikTok nu au adresa de partajare din browser. Daca aparatul
     stie sa partajeze fisiere, ii dam PNG-ul direct si omul alege aplicatia.
     Daca nu, ii descarcam eticheta si ii spunem ce are de facut. */
  function partajeazaApp() {
    etichetaBlob(function (blob) {
      if (!blob) return;
      var f = null;
      try { f = new File([blob], numeFisier(), { type: 'image/png' }); } catch (e) { f = null; }
      if (f && navigator.canShare && navigator.canShare({ files: [f] })) {
        navigator.share({ files: [f], text: textPartajare(), title: 'Blendul meu ONE' }).catch(function () {});
        return;
      }
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = numeFisier();
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
      var nota = q('[data-share] .bl__share-n');
      if (nota) nota.textContent = 'Ți-am descărcat eticheta. Deschide aplicația și încarc-o de acolo.';
    });
  }

  function partajeazaNativ() {
    etichetaBlob(function (blob) {
      if (!blob) return;
      var f = null;
      try { f = new File([blob], numeFisier(), { type: 'image/png' }); } catch (e) { f = null; }
      var date = { text: textPartajare(), url: adresaPaginii(), title: 'Blendul meu ONE' };
      if (f && navigator.canShare && navigator.canShare({ files: [f] })) date.files = [f];
      if (navigator.share) navigator.share(date).catch(function () {});
    });
  }
  /* ---------- cos ---------- */

  /* Ce opreste comanda. Fiecare motiv e separat, ca mesajul de sub buton sa
     spuna exact ce lipseste, nu un "nu se poate" din care omul nu invata nimic.
     Disponibilitatea se verifica pe varianta de 250 g, care e si cea din care
     se descarca, deci nu putem promite ce nu avem. */
  function verificaCos() {
    if (!stare.sloturi.length) return { ok: false, motiv: 'gol' };
    if (suma() !== 100) return { ok: false, motiv: 'reteta' };
    if (!(stare.nume || '').trim()) return { ok: false, motiv: 'nume' };
    for (var i = 0; i < stare.sloturi.length; i++) {
      var c = harta[stare.sloturi[i].h];
      if (!c.v) return { ok: false, motiv: 'varianta', cafea: c.nume };
      if (!c.disp) return { ok: false, motiv: 'stoc', cafea: c.nume };
      /* Cantitatea conteaza doar daca Shopify chiar tine stocul. Cu tracking
         oprit, inventory_quantity e o cifra informativa si comanda trece oricum,
         deci un prag pe ea ar bloca degeaba cafele pe care le putem praji. */
      if (c.urm && c.pol !== 'continue' && c.stoc < unitati[i]) {
        return { ok: false, motiv: 'cantitate', cafea: c.nume, are: c.stoc, cere: unitati[i] };
      }
    }
    return { ok: true };
  }

  function mesajCos(v) {
    if (v.ok) return 'Se adaugă ' + stare.sloturi.length + ' linii, una pentru fiecare origine, în unități de 250 g. Blendul îl amestecăm și îl ambalăm noi, cu eticheta ta.';
    if (v.motiv === 'gol') return 'Alege cafelele din raft, apoi poți comanda direct.';
    if (v.motiv === 'reteta') return 'Rețeta trebuie completată la 100% ca să poți comanda.';
    if (v.motiv === 'nume') return 'Dă-i un nume blendului, la pasul următor. Cu el intră pe etichetă și pe linia de comandă.';
    if (v.motiv === 'varianta') return 'La ' + v.cafea + ' nu găsim unitatea de 250 g. Trimite rețeta și îți răspundem cu o ofertă.';
    if (v.motiv === 'stoc') return v.cafea + ' nu e pe stoc la 250 g. O prăjim la comandă: trimite rețeta și îți confirmăm termenul.';
    if (v.motiv === 'cantitate') return 'La ' + v.cafea + ' avem ' + v.are + ' unități, iar rețeta cere ' + v.cere + '. Scade cantitatea sau trimite rețeta ca ofertă.';
    return '';
  }

  function randeazaCos() {
    if (listaUnitati) {
      listaUnitati.innerHTML = stare.sloturi.map(function (sl, i) {
        var c = harta[sl.h];
        return '<li><b>' + (unitati[i] || 0) + ' × 250 g</b><span>' + c.nume + '</span>' +
               '<i>' + lei(c.pret * (unitati[i] || 0)) + '</i></li>';
      }).join('');
    }
    if (cosTotal) {
      cosTotal.hidden = !stare.sloturi.length;
      cosTotal.innerHTML = 'Total coș <b>' + lei(totalBani()) + '</b> pentru ' + stare.u + ' unități, adică ' + kgText() + '.';
    }
    var v = verificaCos();
    if (btnCos) btnCos.disabled = !v.ok || btnCos.getAttribute('data-lucreaza') === '1';
    if (cosStare) cosStare.textContent = mesajCos(v);
  }

  /* O linie de comanda per origine, pe varianta ei de 250 g. Proprietatile tin
     laolalta liniile aceluiasi blend: numele intra pe eticheta, cheia care
     incepe cu underscore nu se vede clientului dar grupeaza liniile in comanda,
     ca hala sa stie ce se amesteca cu ce. */
  function adaugaInCos() {
    var v = verificaCos();
    if (!v.ok || !btnCos) return;
    var eticheta = (stare.nume || '').trim();
    var autor = (autorInput && autorInput.value || '').trim();
    var cheie = 'blend-' + Date.now().toString(36);
    var linii = stare.sloturi.map(function (sl, i) {
      var c = harta[sl.h];
      var prop = {};
      prop['Blend'] = eticheta;
      prop['Proporție'] = sl.p + '%';
      prop['Măcinare'] = stare.macinare || 'Boabe';
      if (autor) prop['Compus de'] = autor;
      prop['_blend'] = cheie;
      return { id: c.v, quantity: unitati[i], properties: prop };
    });
    btnCos.setAttribute('data-lucreaza', '1');
    btnCos.disabled = true;
    var textVechi = btnCos.textContent;
    btnCos.textContent = 'Se adaugă...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: linii })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        btnCos.removeAttribute('data-lucreaza');
        btnCos.textContent = textVechi;
        if (x.ok) { window.location.href = '/cart'; return; }
        btnCos.disabled = false;
        if (cosStare) cosStare.textContent = (x.d && x.d.description) || 'Nu am putut adăuga blendul în coș. Trimite rețeta și îți răspundem cu o ofertă.';
      })
      .catch(function () {
        btnCos.removeAttribute('data-lucreaza');
        btnCos.textContent = textVechi;
        btnCos.disabled = false;
        if (cosStare) cosStare.textContent = 'Nu am putut adăuga blendul în coș. Verifică legătura la internet sau trimite rețeta ca ofertă.';
      });
  }

  /* ---------- formular ---------- */

  function scrieFormular() {
    for (var i = 0; i < MAX; i++) {
      var sl = stare.sloturi[i];
      if (selCafea[i]) selCafea[i].value = sl ? sl.h : '';
      if (selProcent[i]) selProcent[i].value = sl ? String(sl.p) : '';
    }
    if (selKg) selKg.value = stare.u + ' × 250 g';
    if (selMac && stare.macinare) selMac.value = stare.macinare;

    var pu = pretPeUnitate();
    var p = profil();
    var set = function (n, v) { var el = q('[name="contact[' + n + ']"]'); if (el) el.value = v; };
    set('reteta', stare.sloturi.map(function (sl) {
      var c = harta[sl.h];
      return sl.p + '% ' + c.nume + ' (' + lei(c.pret) + ' / unitate de 250 g)';
    }).join(', '));
    set('nume_blend', stare.nume);
    set('pret_referinta', stare.sloturi.length
      ? lei(pu) + ' unitatea de 250 g, ' + lei(pretPeKg()) + '/kg, total ' + lei(pu * stare.u) +
        ' pentru ' + stare.u + ' unități (' + kgText() + ')'
      : '');
    set('profil', p ? 'Prăjire ' + p.prajire.toFixed(1) + ' din 5, aciditate ' + p.aciditate.toFixed(1) + ' din 5' +
      (p.scor ? ', scor cupping mediu ' + p.scor.toFixed(1) : '') : '');
    set('note_gust', noteBlend().map(function (x) { return x.nume; }).join(', '));
  }

  /* ---------- filtre ---------- */

  function aplicaFiltre() {
    var text = (cautare && cautare.value || '').trim().toLowerCase();
    var active = qa('[data-filtru]').filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })
      .map(function (b) { return b.getAttribute('data-filtru'); });
    var vizibile = 0;
    qa('[data-card]').forEach(function (card) {
      var cauta = card.getAttribute('data-cauta') || '';
      var etich = (card.getAttribute('data-etichete') || '').split(' ');
      var okText = !text || cauta.indexOf(text) > -1;
      var okFiltru = !active.length || active.every(function (f) { return etich.indexOf(f) > -1; });
      var ok = okText && okFiltru;
      card.hidden = !ok;
      if (ok) vizibile++;
    });
    if (contorFiltru) {
      contorFiltru.textContent = vizibile === CAFELE.length
        ? vizibile + ' cafele în raft'
        : vizibile + ' din ' + CAFELE.length + ' cafele';
    }
  }

  /* ---------- evenimente ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-card]');
    if (!t) return;
    if (t.hasAttribute('data-plus')) { var h = t.getAttribute('data-plus'); var i1 = pozitie(h); if (i1 > -1) seteaza(h, stare.sloturi[i1].p + PAS); return; }
    if (t.hasAttribute('data-min')) { var h2 = t.getAttribute('data-min'); var i2 = pozitie(h2); if (i2 > -1) seteaza(h2, stare.sloturi[i2].p - PAS); return; }
    if (t.hasAttribute('data-scoate')) { scoate(t.getAttribute('data-scoate')); return; }
    if (t.hasAttribute('data-echilibreaza')) { echilibreaza(); return; }
    if (t.hasAttribute('data-cos')) { adaugaInCos(); return; }
    if (t.hasAttribute('data-descarca')) { descarcaPng(); return; }
    if (t.hasAttribute('data-share-nativ')) { partajeazaNativ(); return; }
    if (t.hasAttribute('data-share-app')) { partajeazaApp(); return; }
    if (t.hasAttribute('data-share-link')) { deschideLink(t.getAttribute('data-share-link')); return; }
    if (t.hasAttribute('data-filtru')) {
      t.setAttribute('aria-pressed', t.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      aplicaFiltre(); return;
    }
    if (t.hasAttribute('data-u')) {
      var d = parseInt(t.getAttribute('data-u'), 10) || 0;
      var nou = Math.min(UMAX, Math.max(UMIN, stare.u + d));
      if (nou === stare.u) return;
      stare.u = nou;
      randeaza(); return;
    }
    if (t.hasAttribute('data-preset')) { incarcaPreset(t.getAttribute('data-preset')); return; }
    if (t.hasAttribute('data-card')) {
      var hc = t.getAttribute('data-card');
      if (pozitie(hc) > -1) scoate(hc); else adauga(hc);
      return;
    }
  });

  root.addEventListener('keydown', function (e) {
    var seg = e.target.closest('[role="slider"]');
    if (seg) {
      var h = seg.getAttribute('data-h');
      var ip = pozitie(h);
      if (ip < 0) return;
      var cur = stare.sloturi[ip].p;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { seteaza(h, cur + PAS); e.preventDefault(); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { seteaza(h, cur - PAS); e.preventDefault(); }
      else if (e.key === 'Home') { seteaza(h, MIN); e.preventDefault(); }
      else if (e.key === 'End') { seteaza(h, 100); e.preventDefault(); }
    }
  });

  /* Tragerea de manerul din dreapta unui segment. Se prinde pe pointer, deci
     merge si cu degetul, si cu mouse-ul, si cu stylusul. */
  var trag = null;
  banda.addEventListener('pointerdown', function (e) {
    var man = e.target.closest('[data-maner]');
    if (!man) return;
    trag = man.getAttribute('data-maner');
    banda.setPointerCapture(e.pointerId);
    e.preventDefault();
  });
  banda.addEventListener('pointermove', function (e) {
    if (!trag) return;
    var r = banda.getBoundingClientRect();
    var i = pozitie(trag);
    if (i < 0) return;
    var inainte = 0;
    for (var k = 0; k < i; k++) inainte += stare.sloturi[k].p;
    var pct = (e.clientX - r.left) / r.width * 100 - inainte;
    seteaza(trag, pct);
  });
  function opreste(e) {
    if (!trag) return;
    trag = null;
    try { banda.releasePointerCapture(e.pointerId); } catch (x) {}
  }
  banda.addEventListener('pointerup', opreste);
  banda.addEventListener('pointercancel', opreste);

  if (cautare) cautare.addEventListener('input', aplicaFiltre);

  if (numeInput) numeInput.addEventListener('input', function () {
    stare.nume = numeInput.value.slice(0, 32);
    if (contorNume) contorNume.textContent = String(stare.nume.length);
    randeazaEticheta();
    randeazaCos();
    scrieFormular();
  });

  if (autorInput) autorInput.addEventListener('input', randeazaCos);

  if (selMac) selMac.addEventListener('change', function () {
    stare.macinare = selMac.options[selMac.selectedIndex].text;
    randeazaEticheta();
    scrieFormular();
  });

  /* ---------- presetari ---------- */

  function incarcaPreset(reteta) {
    var perechi = reteta.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var noi = [];
    perechi.forEach(function (pp) {
      var parte = pp.split(':');
      var h = (parte[0] || '').trim();
      var p = parseInt(parte[1], 10);
      if (harta[h] && p > 0 && noi.length < MAX) noi.push({ h: h, p: Math.round(p / PAS) * PAS });
    });
    if (!noi.length) return;
    var s = noi.reduce(function (t, x) { return t + x.p; }, 0);
    if (s > 100) return;
    stare.sloturi = noi;
    stare.atins = true;
    randeaza();
    var tinta = q('[data-banc]');
    if (tinta) deruleazaLa(tinta);
  }

  /* In tema asta html si body sunt overflow hidden, iar containerul care
     deruleaza e .page-wrapper. scrollIntoView nu face ce trebuie, deci mutam
     manual scrollTop-ul containerului. */
  function deruleazaLa(el) {
    var sc = document.querySelector('.page-wrapper');
    var lin = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (sc && sc.scrollHeight > sc.clientHeight) {
      var y = el.getBoundingClientRect().top + sc.scrollTop - 24;
      sc.scrollTo({ top: y, behavior: lin });
    } else {
      el.scrollIntoView({ behavior: lin, block: 'start' });
    }
  }

  qa('[data-spre]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = q(b.getAttribute('data-spre'));
      if (t) deruleazaLa(t);
    });
  });

  /* ---------- pornire ---------- */

  if (fallback) fallback.hidden = true;
  root.classList.add('js-activ');
  pregatesteLogo();

  /* Citim starea din formularul nativ, ca sa supravietuiasca unui submit
     esuat, cand Shopify reincarca pagina cu valorile pastrate. */
  for (var j = 0; j < MAX; j++) {
    if (selCafea[j] && selCafea[j].value && harta[selCafea[j].value]) {
      var pv = parseInt(selProcent[j] && selProcent[j].value, 10);
      stare.sloturi.push({ h: selCafea[j].value, p: isNaN(pv) ? MIN : pv });
      stare.atins = true;
    }
  }
  /* Valoarea din select e de forma "8 × 250 g", deci luam numarul din fata. */
  if (selKg && selKg.value) {
    var uv = parseInt(selKg.value, 10);
    if (!isNaN(uv)) stare.u = Math.min(UMAX, Math.max(UMIN, uv));
  }
  if (selMac) stare.macinare = selMac.options[selMac.selectedIndex].text;
  if (numeInput) stare.nume = numeInput.value || '';

  aplicaFiltre();
  randeaza();

  /* Aparitia la derulare. one-home.js nu e incarcat global, deci fiecare
     sectiune isi pune propriul observer. */
  var livrat = false;
  var io = new IntersectionObserver(function (intrari) {
    livrat = true;
    intrari.forEach(function (x) {
      if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  qa('.bl__apar').forEach(function (el) { io.observe(el); });
  /* Plasa de siguranta: daca in trei secunde observerul nu a livrat nicio
     intrare, inseamna ca nu functioneaza si sectiunea ar ramane invizibila.
     Mai bine fara aparitie decat continut ascuns. */
  setTimeout(function () {
    if (livrat) return;
    qa('.bl__apar').forEach(function (el) { el.classList.add('is-in'); });
  }, 3000);
})();
